/** Routes where missing/invalid tokens should not trigger global 401 handling. */
export function isPublicAuthRoute(url: string): boolean {
  const path = url.split('?')[0]?.split('#')[0] ?? '';

  if (path === '' || path === '/') {
    return true;
  }

  if (/^\/auth(?:\/|$)/.test(path)) {
    return true;
  }

  // Invite / link landing pages are reachable before login.
  return (
    /^\/co-parent-invite(?:\/|$)/.test(path) ||
    /^\/parent-link-approval(?:\/|$)/.test(path)
  );
}
